import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { TableRow, TableCell, Typography } from '@material-ui/core';
import Spinner from './Spinner';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: theme.spacing(36),
    },
    text: {
      paddingTop: theme.spacing(2),
    },
  }),
);

interface Props {
  colSpan: number;
  text?: string;
}

const TableLoading: React.FC<Props> = (props) => {
  const { colSpan, text } = props;
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <div className={classes.container}>
          <Spinner />
          {text && (
            <Typography variant='caption' className={classes.text}>
              Loading Messages
            </Typography>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default TableLoading;
